/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const CheckboxWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  margin-top: -10px;
`;

export const Text = styled.p`
  line-height: 16px;
  color: ${Palette.PrimaryGray._600};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`;

export const BidWrap = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

export const ButtonsWrap = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 16px;
`;

export const Strong = styled.strong`
  color: ${Palette.PrimaryGray._900};
`;

export const ErrorHint = styled.div`
  width: 70px;
  line-height: 16px;
  color: ${Palette.Red._600};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  margin-top: 4px;
`;
